import { Breadcrumb } from '../components/PageBreadcrumbs/PageBreadcrumbs';
import { baseUrls } from './urls';

export const homeBreadcrumb = {
  title: 'Support Center',
  url: baseUrls.home
};

const riskLimitBreadcrumb = {
  title: 'Risk limits',
  url: baseUrls.riskLimitsRequests
};

const manageLimitBreadcrumb = {
  title: 'Manage limits',
  url: baseUrls.manageAccountLimits
};

const acrBreadcrumb = {
  title: 'Account Changes',
  url: baseUrls.accountChangeRequests
};

const generalRequestBreadcrumb = {
  title: 'General requests',
  url: baseUrls.generalRequests
};

const cashMovementRequestBreadcrumb = {
  title: 'Cash Movement Requests',
  url: baseUrls.cashMovementRequests
};

export const conciergeMap: Record<string, Breadcrumb[]> = {
  [baseUrls.home]: [],

  [baseUrls.newKybSubmission]: [
    {
      title: 'KYB requests',
      url: baseUrls.kybRequests
    },
    {
      title: 'New KYB submission',
      url: baseUrls.newKybSubmission
    }
  ],
  [baseUrls.kybRequests]: [
    {
      title: 'KYB requests',
      url: baseUrls.kybRequests
    }
  ],
  [baseUrls.signDocument]: [
    {
      title: 'KYB requests',
      url: baseUrls.kybRequests
    },
    {
      title: 'New KYB submission',
      url: baseUrls.newKybSubmission
    },
    {
      title: 'Sign document',
      url: baseUrls.signDocument
    }
  ],

  [baseUrls.riskLimitsRequests]: [riskLimitBreadcrumb],
  [baseUrls.riskLimitsRequest]: [
    riskLimitBreadcrumb,
    {
      title: 'Request :id',
      url: baseUrls.riskLimitsRequest
    }
  ],

  [baseUrls.manageAccountLimits]: [riskLimitBreadcrumb, manageLimitBreadcrumb],

  [baseUrls.manageAccountLimit]: [
    riskLimitBreadcrumb,
    manageLimitBreadcrumb,
    {
      title: 'Account :id'
    }
  ],

  [baseUrls.accountChangeRequests]: [acrBreadcrumb],
  [baseUrls.accountChangeRequest]: [
    acrBreadcrumb,
    {
      title: 'Request :id',
      url: baseUrls.accountChangeRequest
    }
  ],

  [baseUrls.generalRequests]: [generalRequestBreadcrumb],
  [baseUrls.createGeneralRequest]: [
    {
      title: 'General requests',
      url: baseUrls.generalRequests
    },
    {
      title: 'New Request'
    }
  ],
  [baseUrls.generalRequest]: [
    {
      title: 'General requests',
      url: baseUrls.generalRequests
    },
    {
      title: 'View request'
    }
  ],
  [baseUrls.cashMovementRequests]: [cashMovementRequestBreadcrumb],
  [baseUrls.cashMovementNewRequest]: [
    cashMovementRequestBreadcrumb,
    {
      title: 'New Request'
    }
  ],
  [baseUrls.cashMovementBulkRequest]: [
    cashMovementRequestBreadcrumb,
    {
      title: 'Bulk Request'
    }
  ],
  [baseUrls.cashMovementRequest]: [
    cashMovementRequestBreadcrumb,
    {
      title: 'Request :id',
      url: baseUrls.cashMovementRequest
    }
  ]
};
